import React from 'react'
import LeftmenuIn from '../Components/LeftmenuIn'
import DashnavIn from '../Components/DashnavIn'
import ThoughtsComp from './ThoughtsComp'

function MyThoughts() {
  return (
    <div className='mainContainer'>
        <LeftmenuIn/>
        <div className='theMainContainer'>
        <DashnavIn/>
        <ThoughtsComp/>
        
        </div>
    </div> 
  )
}

export default MyThoughts